import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useApi } from '../../hooks/useApi';
import { Kyc, ApiKyc } from '../../models/Kyc';
import Spinner from '../../components/Spinner';

const NewbieMessageDonee = () => {
  const [ kyc, setKyc ] = useState<Kyc>();
  const { get, loading } = useApi();

  const isKycSubmitted = kyc && ['SUBMITTED', 'AUTO_CERTIFIED', 'MAN_CERTIFIED'].includes(kyc.status);

  useEffect(() => {
    get({
      endpoint: '/api/v1/kycs/me',
      onSuccess: (data) => {
        const apiKyc: ApiKyc = data.data;
        setKyc(new Kyc(apiKyc));
      }
    })
  }, [ get ]);

  return (
    <div className="border_box pink">
      { !loading && !isKycSubmitted && (
        <div className="newbie_message">
          <strong>初めてご利用の方へ</strong>
          <p>Ton Bébéにご登録いただきありがとうございます。</p>
          <p>初めてご利用になられる方には、まずは<Link to="/mypage/kyc">本人確認</Link>をお願いしております。</p>
          <p>その後、<Link to="/search-result">ドナーを検索</Link>し、興味のある・気になるドナーがいらっしゃいましたら、メッセージを送ってみましょう。</p>
          <p>メッセージのやり取りをしてみて、希望にあうドナーでしたら提供に進みましょう。</p>
          <p>提供後にドナーから提供実績申請が届きましたら、<Link to="/mypage/records">提供実績</Link>より「承認」をお願いいたします。</p>
          <p>※このメッセージは本人確認を提出すると表示されなくなります。</p>
        </div>
      ) }

      <div className="status">
        <section>
          <h3 className="sub_title">登録状況</h3>
          <div className="wrap">
            <dl className="graf_list pink">
              <dt>本人確認</dt>
              <dd>
                { loading ? <Spinner size="small" /> : isKycSubmitted ? <span className="done">登録済</span> : <span>未登録 (<Link to="/mypage/kyc">登録する</Link>)</span> }
              </dd>
            </dl>
          </div>
        </section>
      </div>
    </div>
  )
}

export default NewbieMessageDonee;
